import api from "../api";
class HomeRepository {
  async getLocation() {
    try {
      const response = await api.get("/location");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default HomeRepository;
